export const extName = "liplum-trends-widget"
